<template>
  <div>
    <div class="pl-7 pt-4">
      <div class="font-primaria headline font-weight-bold fontColor1--text">
        DIRIGENTES
      </div>

      <div style="line-height: 8px;" class="font-secundaria subtitle-2 fontColor1--text" v-if="!$vuetify.breakpoint.xs">
        Home > <span class="font-weight-bold"> Dirigentes </span>
      </div>

      <div class="font-secundaria subtitle-2 fontColor1--text" v-else>
        Home > <span class="font-weight-bold"> Dirigentes </span>
      </div>
    </div>
    <v-row>
      <v-col cols="12" class="px-6">
        <v-card class="white card-consulta">
          <v-row align="center" :class="!$vuetify.breakpoint.xs ? 'px-8 py-2' : 'px-4'" justify="end">
            <v-col cols="12" sm="5">
              <search-bar
                nameInput="searchText"
                nameButton="searchBtn"
                ref="barraPesquisa"
                v-model="barraPesquisa"
                placeholder="pesquisar por nome, crm ou cpf"
                @pesquisar="pesquisar"
              />
            </v-col>

            <v-col cols="auto" class="mt-2" @click="exportar">
              <icon name="download" :size="20" style="cursor: pointer;" tooltip="Exportar" />
            </v-col>

            <v-col cols="auto">
              <button-cadu name="btnLimpar" outline @click="limparFiltro()"> LIMPAR </button-cadu>
            </v-col>

            <v-col cols="auto">
              <button-cadu @click="showFiltro = true">
                FILTRAR
              </button-cadu>
            </v-col>
          </v-row>

          <v-row :class="!$vuetify.breakpoint.xs ? 'px-8 py-2' : 'px-2'">
            <v-col cols="12">
              <TabelaDirigentes
                ref="tabelaDirigentes"
                :cpf="filtro.cpf"
                :crm="filtro.crm"
                :nome="filtro.nome"
                :unimedId="filtro.unimedId"
                :campoPesquisa="campoPesquisa"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <div>
      <FiltroDirigentes v-model="showFiltro" @filtrar="(filtro) => filtrar(filtro)" ref="filtroDirigentes" />
    </div>
  </div>
</template>

<script>
import TabelaDirigentes from './Shared/TabelaDirigentes'
import FiltroDirigentes from './Shared/FiltroDirigentes'

export default {
  components: {
    TabelaDirigentes,
    FiltroDirigentes
  },
  data() {
    return {
      showFiltro: false,
      barraPesquisa: '',
      filtro: {
        nome: '',
        cpf: '',
        crm: '',
        unimedId: ''
      },
      campoPesquisa: ''
    }
  },
  methods: {
    async limparFiltro() {
      this.barraPesquisa = ''
      this.campoPesquisa = ''
      await this.$nextTick()
      this.$refs.filtroDirigentes.limparFiltro()
      this.$refs.tabelaDirigentes.pagina = 1
      this.$refs.filtroDirigentes.filtraAnexos()
    },
    async pesquisar() {
      this.campoPesquisa = this.barraPesquisa
      await this.$nextTick()
      this.$refs.tabelaDirigentes.pagina = 1
      this.$refs.tabelaDirigentes.getDirigenteTabela()
    },
    async exportar() {
      await this.$nextTick()
      this.$refs.tabelaDirigentes.exportar()
    },
    async filtrar(filtro) {
      this.showFiltro = false
      this.filtro = { ...filtro }
      await this.$nextTick()
      this.$refs.tabelaDirigentes.getDirigenteTabela()
    }
  }
}
</script>

<style lang="sass" scoped>
.card-consulta
    width: 100%
    min-height: 420px
    border-radius: 20px
</style>
